 <!-- Modal -->
 <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" #closebutton aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Please wait. Redeem transaction is in progress. 
        </div>
      </div>
    </div>
  </div>